import {useState } from 'react'
import PurchaseWindowPaymentSuccess from './PurchaseWindowPaymentSuccess';
import PurchaseWindowPaymentFailed from './PurchaseWindowPaymentFailed';
import useEffectOnce from 'hooks/useEffectOnce';
import { useLocation, useNavigate } from 'react-router-dom';
import ModalWindow from 'components/ModalWindow';

const PurchaseWindowPaymentCard = () => {
  const {pathname, search } = useLocation();
  const navigate = useNavigate();
  const [isPaymentPopup, setIsPaymentPopup] = useState(false);
  const [paymentPopupType, setPaymentPopupType] = useState('true');
  const params = new URLSearchParams(search);

  useEffectOnce(() => {
    if (params.has('success')) {
      setIsPaymentPopup(true);
      const statusValue = params.get('success');
      setPaymentPopupType(statusValue);
      params.delete('success');
      navigate(`${pathname}?${params.toString()}`, { replace: true });
  }
  })

  const closePaymentSuccess = () => setIsPaymentPopup(false);

  return (
    <ModalWindow additionalClass='modal-window--purchase' close={closePaymentSuccess}>
      {isPaymentPopup && paymentPopupType === 'true' ? <PurchaseWindowPaymentSuccess close={closePaymentSuccess} /> : null}
      {isPaymentPopup && paymentPopupType === 'false' ? <PurchaseWindowPaymentFailed close={closePaymentSuccess} /> : null}
    </ModalWindow>
  )
}

export default PurchaseWindowPaymentCard;
